import LocationList from './LocationList';

export default LocationList;
export * from './LocationList';
